

// services
import { SettlementDebt } from '../../models/Entities/SettlementDebt/SettlementDebt';
import { ErrorType } from '../../models/HttpError';
import * as Services from '../../services/Settlements.Services';

// actions
import * as Actions from '../actions';
import { AppThunkAction } from '../reducers';

type KnownAction =
 | Actions.Settlements.Settlement_GetDebtsBySettlementId_Request_Action
 | Actions.Settlements.Settlement_GetDebtsBySettlementId_Receive_Action
 | Actions.Settlements.Settlement_GetDebtsBySettlementId_Fail_Action;

export const actionCreators = {
    GetSettlementDebtsBySettlementId:
        (settlementId: number): AppThunkAction<KnownAction> =>
        async (dispatch, getState) => {
            var state = getState();
            var token: string = '';
            if (state.oidc?.user) {
                token = state.oidc?.user?.access_token;
            } else {
                dispatch({
                    type: 'SETTLEMENT_GETDEBTSBYSETTLEMENTID_FAIL_ACTION',
                    settlementId: settlementId,
                    error: {
                        ErrorCode: 401,
                        ErrorMessage: 'Unauthorized',
                        Errors: []
                    }
                });
                return;
            }
            dispatch({
                type: 'SETTLEMENT_GETDEBTSBYSETTLEMENTID_REQUEST_ACTION',
                settlementId: settlementId
            });
            Services.GetSettlementDebts(settlementId, token)
            .then((debts: SettlementDebt[]) => {
                dispatch({
                    type: 'SETTLEMENT_GETDEBTSBYSETTLEMENTID_RECEIVE_ACTION',
                    debts: debts,
                    settlementId: settlementId
                });
            })
            .catch((error: ErrorType) =>
                dispatch({
                    type: 'SETTLEMENT_GETDEBTSBYSETTLEMENTID_FAIL_ACTION',
                    settlementId: settlementId,
                    error: error
                })
            );
        }
    };

    